import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import './BrandOnboardingCreateModal.scss';

import BrandOnboardingOverlay from './BrandOnboardingOverlay';
import BrandOnboardingEditor from './BrandOnboardingEditor';

const BrandOnboardingCreateModal = props => {
  const { fields, onFieldChange, collapsedSectionTitles, onToggleSectionCollapsed, recipientNamesById } = props;
  const { isLoading, onCreate, onRequestClose } = props;

  const modalRef = useRef(null);
  useEffect(() => {
    requestAnimationFrame(() => modalRef.current?.querySelector('input, select, textarea')?.focus());
  }, []);

  const header = (
    <div className='brand-onboarding-editor-header'>
      <div>
        <div className='brand-onboarding-editor-title'>New Registration Code</div>
        <div className='brand-onboarding-editor-meta subtitle'>Create a code, then send it to the brand to start onboarding.</div>
      </div>
    </div>
  );

  const actions = (
    <>
      <button className='brand-onboarding-result-button cancel' onClick={onRequestClose}>
        Cancel
      </button>
      <button className={cn('brand-onboarding-result-button save', { disabled: isLoading })} disabled={isLoading} onClick={onCreate}>
        {isLoading ? 'Saving...' : 'Create Code'}
      </button>
    </>
  );

  return (
    <BrandOnboardingOverlay onRequestClose={onRequestClose}>
      <div className='brand-onboarding-create-modal-outer-container' ref={modalRef} onClick={e => e.stopPropagation()}>
        <div className='brand-onboarding-create-modal-inner-container'>
          <BrandOnboardingEditor
            fields={fields}
            isFieldEditable={() => true}
            onFieldChange={onFieldChange}
            collapsedSectionTitles={collapsedSectionTitles}
            onToggleSectionCollapsed={onToggleSectionCollapsed}
            recipientNamesById={recipientNamesById}
            header={header}
            actions={actions}
          />
        </div>
      </div>
    </BrandOnboardingOverlay>
  );
};

BrandOnboardingCreateModal.propTypes = {
  fields: PropTypes.array.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  collapsedSectionTitles: PropTypes.object.isRequired,
  onToggleSectionCollapsed: PropTypes.func.isRequired,
  recipientNamesById: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  onCreate: PropTypes.func.isRequired,
  onRequestClose: PropTypes.func.isRequired
};

export default BrandOnboardingCreateModal;
